import { faRecycle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Carousel } from "flowbite-react";
import React from "react";

export default function AboutTestimonial() {
  return (
    <div className="container mt-20">
      <div className="text-center">
        <FontAwesomeIcon icon={faRecycle} className="text-3xl text-lime-600" />

        <h5 className="font-bold text-5xl mt-2">Testimonials</h5>
        <p className="text-base">What Client Say</p>
      </div>

      <div className="flex justify-center items-center my-10 md:my-0">
        <div className="h-96 md:h-56 w-3/4 sm:h-64 xl:h-80 2xl:h-96">
          <Carousel>
            <div className="text-center">
              <div className="flex justify-center items-center">
                <div className="rounded-full">
                  <img
                    src={require("../../images/user.png")}
                    alt="User"
                    className="mx-auto w-32"
                  />
                </div>
              </div>

              <p className="text-slate-400 text-2xl mt-3">
                "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim
                voluptas id explicabo laboriosam sit tempora molestias,
                accusamus commodi odit ut alias similique, fugiat iure fuga
                autem sequi minus harum et."
              </p>
              <h5 className="text-xl mt-5">User Customer</h5>
              <p className="text-base text-slate-400">DIRECTOR</p>
            </div>

            <div className="text-center">
              <div className="flex justify-center items-center ">
                <div className="rounded-full">
                  <img
                    src={require("../../images/user.png")}
                    alt="User"
                    className="mx-auto w-32"
                  />
                </div>
              </div>

              <p className="text-slate-400 text-2xl mt-3">
                "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim
                voluptas id explicabo laboriosam sit tempora molestias,
                accusamus commodi odit ut alias similique, fugiat iure fuga
                autem sequi minus harum et."
              </p>
              <h5 className="text-xl mt-5">User Customer</h5>
              <p className="text-base text-slate-400">DIRECTOR</p>
            </div>

            <div className="text-center">
              <div className="flex justify-center items-center ">
                <div className="rounded-full">
                  <img
                    src={require("../../images/user.png")}
                    alt="User"
                    className="mx-auto w-32"
                  />
                </div>
              </div>

              <p className="text-slate-400 text-2xl mt-3">
                "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim
                voluptas id explicabo laboriosam sit tempora molestias,
                accusamus commodi odit ut alias similique, fugiat iure fuga
                autem sequi minus harum et."
              </p>
              <h5 className="text-xl mt-5">User Customer</h5>
              <p className="text-base text-slate-400">DIRECTOR</p>
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
}
